<template>
  <v-hover v-slot="{ hover }">
    <v-card height="100%" class="overflow-hidden">
      <v-card-subtitle class="pb-1 lighttext--text d-flex">
        <div>By {{ resource.author }}</div>
        <v-spacer />
        <div v-if="resource.shares > 0">{{ resource.shares }} Shares</div>
      </v-card-subtitle>
      <v-card-title class="pt-1">
        {{ resource.title }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="auto" v-if="resource.imageUrl">
            <v-avatar size="60">
              <v-img :src="resource.imageUrl"></v-img>
            </v-avatar>
          </v-col>
          <v-spacer />
          <v-col class="text-right lighttext--text">
            <div>
              {{ resource.typeName }}
            </div>
            <div v-if="resource.timeToConsume > 0">
              {{ resource.timeToConsume }} Minutes
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-fade-transition>
        <v-overlay v-if="hover" absolute color="white" class="text-center">
          <v-row dense>
            <v-col cols="12" class="mx-auto">
              <v-btn
                outlined
                color="secondarytext"
                style="background-color: #fff;"
                class="my-2"
                target="_blank"
                :href="resource.url"
                block
              >
                <v-icon class="mr-2">
                  search
                </v-icon>
                View
              </v-btn>
            </v-col>
            <v-col cols="12" class="mx-auto">
              <v-btn
                outlined
                color="secondarytext"
                style="background-color: #fff;"
                class="my-2"
                @click="showSchedule"
                block
              >
                <v-icon class="mr-2">
                  send
                </v-icon>
                Share
              </v-btn>
            </v-col>
          </v-row>
        </v-overlay>
      </v-fade-transition>
      <resource-schedule-dialog
        :resourceId="resource.id"
        ref="scheduleDialog"
      ></resource-schedule-dialog>
    </v-card>
  </v-hover>
</template>

<script>
import ResourceScheduleDialog from "@/components/resources/ResourceScheduleDialog";
export default {
  name: "ResourceLibraryCard",
  components: { ResourceScheduleDialog },
  props: { resource: { type: Object } },
  data: () => ({ hover: false }),
  methods: {
    showSchedule() {
      this.$refs.scheduleDialog.showDialog(this.resource.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.badge-background {
  position: absolute;
  bottom: -75px;
  right: 16px;
}

::v-deep .cls-1 {
  fill: inherit !important;
}
</style>
